import React from 'react';
import "./home.css";
import IphoneX from "../../icons/iphonex.png";
import Laptop from "../../icons/laptop2.png";

export default function Home() {
  const url = "https://portal.notifier-global.com/login";

  // Google Analytics event tracking
  const trackEvent = (eventName, eventParams) => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', eventName, eventParams);
    }
  };

  const handleGetStarted = (location) => {
    trackEvent('cta_click', {
      'button_name': 'Get Started Free',
      'button_location': location,
      'page_location': window.location.href
    });
    window.open(url);
  };

  const handleViewPricing = () => {
    trackEvent('navigation_click', {
      'button_name': 'View Pricing',
      'button_location': 'hero',
      'destination': '#pricing'
    });
    window.location.hash = '#pricing';
  };

  const handleStartTrial = () => {
    trackEvent('cta_click', {
      'button_name': 'Start Your Free Trial',
      'button_location': 'pricing_section',
      'page_location': window.location.href
    });
    window.open(url);
  };

  return (
    <div className='home-container'>
      {/* Hero Section */}
      <section className='hero-section'>
        <div className='hero-content'>
          <div className='hero-text'>
            <h1 className='hero-title'>
              Simple Notifications.<br/>
              <span className='hero-highlight'>Anywhere. Anytime.</span>
            </h1>
            <p className='hero-subtitle'>
              Embed a URL in your code and get instant mobile notifications. No complex integrations. No surprise costs.
            </p>
            <div className='hero-buttons'>
              <button className='cta-primary' onClick={() => handleGetStarted('hero')}>
                Get Started Free
              </button>
              <button className='cta-secondary' onClick={handleViewPricing}>
                View Pricing
              </button>
            </div>
          </div>
          <div className='hero-image'>
            <img src={IphoneX} className='hero-phone' alt='Notifier Mobile App' width="300" height="600"/>
            <img src={Laptop} className='hero-laptop' alt='Notifier Dashboard' width="500" height="350"/>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className='mission-section' id='mission'>
        <div className='section-container'>
          <h2 className='section-title'>Our Mission</h2>
          <div className='mission-content'>
            <p className='mission-text'>
              Notifier is a general notification platform that helps anyone embed a dedicated URL in their code 
              and get notified on anything they need. It can be embedded in a website, in any website functionality, 
              and even in <strong>IoT devices</strong> (which is super important).
            </p>
            <p className='mission-text'>
              Our mission is to allow anyone to use any notification they need on their mobile phone at any time 
              and from anywhere they want — and the most important part is that <strong>it's cheap!</strong>
            </p>
            <div className='mission-highlights'>
              <div className='highlight-card'>
                <div className='highlight-icon'>📱</div>
                <h3>No Unknown Numbers</h3>
                <p>No more text messages from unknown numbers cluttering your phone</p>
              </div>
              <div className='highlight-card'>
                <div className='highlight-icon'>⚡</div>
                <h3>Easy Integration</h3>
                <p>No more hard integration processes or complex setups</p>
              </div>
              <div className='highlight-card'>
                <div className='highlight-icon'>💰</div>
                <h3>Fixed Pricing</h3>
                <p>No surprise costs — know exactly what you'll pay</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className='offer-section' id='offer'>
        <div className='section-container'>
          <h2 className='section-title'>What We Offer</h2>
          <p className='section-subtitle'>
            A cheap, fixed-price subscription to a platform that allows you to create a simple URL 
            that you can embed in your code.
          </p>
          <div className='offer-grid'>
            <div className='offer-card'>
              <div className='offer-number'>01</div>
              <h3>Create URLs in Seconds</h3>
              <p>Generate a dedicated notification URL in less than a minute. So simple you'll wonder why you didn't find us sooner.</p>
            </div>
            <div className='offer-card'>
              <div className='offer-number'>02</div>
              <h3>Sign In to Mobile App</h3>
              <p>Download our mobile app, sign in, and manage all your alerts from one beautiful interface.</p>
            </div>
            <div className='offer-card'>
              <div className='offer-number'>03</div>
              <h3>Manage Your Alerts</h3>
              <p>Configure, customize, and control your notifications. Subscribe to alerts from others and never miss a thing.</p>
            </div>
            <div className='offer-card'>
              <div className='offer-number'>04</div>
              <h3>Embed Anywhere</h3>
              <p>Use in websites, backend services, IoT devices, automation scripts — anywhere you can make an HTTP request.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className='pricing-section' id='pricing'>
        <div className='section-container'>
          <h2 className='section-title'>Simple, Transparent Pricing</h2>
          <p className='section-subtitle'>No hidden fees. No surprises. Just straightforward pricing.</p>
          <div className='pricing-grid'>
            <div className='pricing-card-free'>
              <h3 className='pricing-plan'>Free Plan</h3>
              <div className='pricing-amount'>
                <span className='currency'>$</span>
                <span className='price'>0</span>
                <span className='period'>/forever</span>
              </div>
              <ul className='pricing-features'>
                <li>✓ 2 notification managers</li>
                <li>✓ 20 notifications per day</li>
                <li>✓ Mobile app access</li>
                <li>✓ Real-time delivery</li>
                <li>✓ Alert management dashboard</li>
                <li>✓ Share alerts with others</li>
              </ul>
              <button className='pricing-cta-free' onClick={() => handleGetStarted('pricing_free')}>
                Get Started Free
              </button>
              <p className='pricing-note'>Perfect for getting started</p>
            </div>
            <div className='pricing-card-featured'>
              <div className='pricing-badge'>Most Popular</div>
              <h3 className='pricing-plan'>Unlimited Plan</h3>
              <div className='pricing-amount'>
                <span className='currency'>$</span>
                <span className='price'>5</span>
                <span className='period'>/month</span>
              </div>
              <ul className='pricing-features'>
                <li>✓ Unlimited notifications</li>
                <li>✓ Unlimited subscribers</li>
                <li>✓ Unlimited notification managers</li>
                <li>✓ Mobile app access</li>
                <li>✓ Real-time delivery</li>
                <li>✓ Alert management dashboard</li>
                <li>✓ Share alerts with others</li>
                <li>✓ Priority support</li>
              </ul>
              <button className='pricing-cta' onClick={handleStartTrial}>
                Start Your Free Trial
              </button>
              <p className='pricing-note'>Yes, it's that simple. $5/month for everything.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How We Can Help Section */}
      <section className='help-section' id='help'>
        <div className='section-container'>
          <h2 className='section-title'>How We Can Help</h2>
          <div className='help-content'>
            <div className='help-main'>
              <h3>Simplify Your Notification Process</h3>
              <p>
                We provide you with a URL per alert that you can simply make a request to in your code. 
                The alert that you configured will be sent to any subscribed mobile device instantly.
              </p>
              <div className='help-steps'>
                <div className='help-step'>
                  <span className='step-number'>1</span>
                  <div className='step-content'>
                    <h4>Create Your Alert URL</h4>
                    <p>Log in to the portal and generate a unique notification URL</p>
                  </div>
                </div>
                <div className='help-step'>
                  <span className='step-number'>2</span>
                  <div className='step-content'>
                    <h4>Embed in Your Code</h4>
                    <p>Make a simple HTTP request to your URL whenever you need to send a notification</p>
                  </div>
                </div>
                <div className='help-step'>
                  <span className='step-number'>3</span>
                  <div className='step-content'>
                    <h4>Share & Subscribe</h4>
                    <p>Copy/paste a link and send it to whoever wants to get notified</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='help-examples'>
              <h4>Perfect For:</h4>
              <ul className='help-list'>
                <li>🏠 Home automation & IoT devices</li>
                <li>🖥️ Server monitoring & alerts</li>
                <li>📊 Business metrics & KPI notifications</li>
                <li>🛒 E-commerce order updates</li>
                <li>🔔 Custom webhooks & integrations</li>
                <li>⚠️ Error tracking & system alerts</li>
                <li>📈 Data pipeline notifications</li>
                <li>🤖 Bot & automation updates</li>
              </ul>
            </div>
          </div>
          <div className='help-cta'>
            <h3>You won't believe how simple it is...</h3>
            <button className='cta-primary' onClick={() => handleGetStarted('help_section')}>
              Try It Now — It's Free!
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}
